<div class="map-frame">
  <div id={{inject.div_name}} class="map" style="text-align: center ; vertical-align: center;"> 
    @if(loading){
      <div [@inOutAnimation] >
        <h3 > Loading map... </h3>
        <img src="assets/images/loader_cms.gif" style="width: 250px;" alt="no data"   />
      </div>
    }
   </div>
</div>